var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-circle",style:({'background-color':_vm.driverBgColor})},[_vm._v(_vm._s(_vm.firstLetter)+_vm._s(_vm.secondLetter))])
}
var staticRenderFns = []

export { render, staticRenderFns }